<template>
  <el-breadcrumb
    class="app-breadcrumb"
    separator-class="el-icon-arrow-right"
    v-show="showBreadcrumb"
  >
    <div class="app-breadcrumb-container">
      <transition-group name="breadcrumb">
        <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
          <span class="item-wrapper">
            <i
              :class="{
                'breadcrumb-icon': true,
                'level-1': index === 0,
                'level-2': index > 0,
                active: index === levelList.length - 1,
              }"
            />
            <span
              v-if="
                index === levelList.length - 1 ||
                (item.redirect === 'noRedirect' && levelList.length === 1)
              "
              class="title active"
            >
              {{ item.meta.title }}
            </span>
            <a v-else class="title link" @click.prevent="handleLink(item)">
              {{ item.meta.title }}
            </a>
          </span>
        </el-breadcrumb-item>
      </transition-group>
    </div>
  </el-breadcrumb>
</template>

<script>
export default {
  data() {
    return {
      levelList: null,
    };
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith("/redirect/")) {
        return;
      }
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  computed: {
    showBreadcrumb() {
      const route = this.$route || {};
      const query = route.query || {};
      const meta = route.meta || {};
      const hideByQuery =
        query.hideNav === "1" ||
        query.hideNav === 1 ||
        query.hideNav === true ||
        query.hideNav === "true";
      const hideByMeta = meta.hideBreadcrumb === true || meta.hideNav === true;
      return !(hideByQuery || hideByMeta);
    },
  },
  methods: {
    getBreadcrumb() {
      // only show routes with meta.title
      const matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title
      );
      // remove auto-prepending of "首页"; show exactly current matched chain
      this.levelList = matched.filter(
        (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false
      );
    },
    isDashboard(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      return name.trim() === "Index";
    },
    handleLink(item) {
      const { redirect, path } = item;
      // allow parent with children to navigate by its own path when redirect is 'noRedirect'
      if (redirect && redirect !== "noRedirect") {
        this.$router.push(redirect);
      } else {
        this.$router.push(path);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  width: 100%;
  height: 55px;
  border-bottom: 1px dashed #d8dfef;
  display: inline-block;
  background-color: #eff3fc;
  padding: 0;
  font-size: 14px;
  line-height: 32px;
  .app-breadcrumb-container {
    border-radius: 30px 30px 0 0;
    width: 100%;
    height: 100%;
    padding: 10px 24px 0;
    background-color: #fff;
  }
  .item-wrapper {
    display: inline-flex;
    align-items: center;
  }

  .breadcrumb-icon {
    width: 16px;
    height: 16px;
    margin-right: 6px;

    &.level-1 {
      background: url(../../assets/images/first-menu.png) no-repeat;

      &.active {
        background-image: url(../../assets/images/first-menu-selected.png);
      }
    }

    &.level-2 {
      background: url(../../assets/images/second-menu.png) no-repeat;

      &.active {
        background-image: url(../../assets/images/second-menu-selected.png);
      }
    }
  }

  .title.link {
    cursor: auto;
    color: #0f3171;
  }

  .title.active {
    color: #0057ff;
    font-weight: 600;
  }

  ::v-deep .el-breadcrumb__separator {
    color: #a7b1c5;
    margin: 0 10px;
    font-weight: 400;
  }
  ::v-deep .el-breadcrumb__item {
    display: flex;
    align-items: center;
    height: 35px;
    .el-icon-arrow-right {
      margin-top: -4px;
    }
  }
}
</style>
